export function match(param) {
    return param?.length < 18;
}